var version = {
    "name":      "dativery",
    "buildDateCode": "20260901-131557",
    "buildDate": "Tue Sep 01 2026 13:15:57 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260901-131557",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;